import { Injectable } from '@angular/core';


@Injectable()
export class CustomvalidationService {

  constructor() { }
   

  	

}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/authentication/customvalidation.service.ts